import { createReducer, on } from '@ngrx/store';
import * as ParametersDataActions from './parameters-data.actions';
import { ParameterData } from 'src/app/pages/admin-manager/parameters/models/parameters.model';

export interface ParametersDataState {
  response: string | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: ParameterData };
  loadingByKey?: { [key: string]: boolean };
  errorByKey?: { [key: string]: any };
}

export const initialState: ParametersDataState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
  loadingByKey: {},
  errorByKey: {},
};

export const parametersDataReducer = createReducer(
  initialState,
  on(ParametersDataActions.loadParametersData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ParametersDataActions.requestParametersDataByKeys, (state, { keys }) => {
    const nextLoadingByKey = { ...(state.loadingByKey || {}) };
    for (const key of keys || []) {
      nextLoadingByKey[key] = true;
    }
    return {
      ...state,
      loading: true,
      loadingByKey: nextLoadingByKey,
      error: null,
    };
  }),
  on(ParametersDataActions.loadParametersDataSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(ParametersDataActions.loadParametersDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ParametersDataActions.loadParametersDataSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    cache: { ...(state.cache || {}), [key]: response },
    loadingByKey: { ...(state.loadingByKey || {}), [key]: false },
    errorByKey: { ...(state.errorByKey || {}), [key]: null },
    error: null,
  })),
  on(ParametersDataActions.loadParametersDataSuccessMany, (state, { entries }) => {
    const nextCache = { ...(state.cache || {}) };
    const nextLoadingByKey = { ...(state.loadingByKey || {}) };
    const nextErrorByKey = { ...(state.errorByKey || {}) };
    for (const entry of entries || []) {
      nextCache[entry.key] = entry.response;
      nextLoadingByKey[entry.key] = false;
      nextErrorByKey[entry.key] = null;
    }
    const anyLoading = Object.values(nextLoadingByKey).some(Boolean);
    return {
      ...state,
      loading: anyLoading,
      cache: nextCache,
      loadingByKey: nextLoadingByKey,
      errorByKey: nextErrorByKey,
      error: null,
    };
  }),
  on(ParametersDataActions.loadParametersDataFailureByKeys, (state, { keys, error }) => {
    const nextLoadingByKey = { ...(state.loadingByKey || {}) };
    const nextErrorByKey = { ...(state.errorByKey || {}) };
    for (const key of keys || []) {
      nextLoadingByKey[key] = false;
      nextErrorByKey[key] = error;
    }
    const anyLoading = Object.values(nextLoadingByKey).some(Boolean);
    return {
      ...state,
      loading: anyLoading,
      loadingByKey: nextLoadingByKey,
      errorByKey: nextErrorByKey,
      error,
    };
  }),
);
